module.exports = __webpack_public_path__ + "media/images/pic/brodno/video-shadow-f5ca3375ca6371eb2e5b674bde94fdbd.png";